module.exports = __webpack_public_path__ + "static/img/usp.f80f5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/usp.png
// module id = OFkA
// module chunks = 1